import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared layout for legal pages.
 * props: { eyebrow, title, lastUpdated, sections: [{ heading, body }] }
 */
export default function LegalLayout({ eyebrow, title, lastUpdated, sections }) {
  useEffect(() => { window.scrollTo(0, 0); }, [title]);

  return (
    <div className="py-12 md:py-20" data-testid="legal-page">
      <div className="container-vdz max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-serif-accent opacity-60 hover:opacity-100 hover:text-[color:var(--vdz-gold)] mb-8">
          <ArrowLeft size={14} /> Acasă
        </Link>

        <div className="eyebrow mb-4">{eyebrow}</div>
        <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.05]" style={{ color: "var(--vdz-navy)" }}>
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-6 text-xs uppercase tracking-[0.22em] font-serif-accent opacity-60">
            Actualizat: {lastUpdated}
          </p>
        )}

        <div className="gold-divider my-12"><span className="eyebrow">VIS DE ZI</span></div>

        <article className="space-y-12">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-serif-display text-2xl md:text-3xl mb-4" style={{ color: "var(--vdz-navy)" }}>
                {`${i + 1}. ${s.heading}`}
              </h2>
              <div className="space-y-4 leading-[1.85] text-[16px]" style={{ color: "var(--vdz-text-body)" }}>
                {Array.isArray(s.body)
                  ? s.body.map((p, j) =>
                      typeof p === "string" ? <p key={j}>{p}</p> : <React.Fragment key={j}>{p}</React.Fragment>
                    )
                  : s.body}
              </div>
            </section>
          ))}
        </article>

        <div className="mt-16 text-center">
          <p className="opacity-60 text-sm mb-5">Ai întrebări? Scrie-ne oricând.</p>
          <Link to="/contact" className="btn-gold">Contactează-ne</Link>
        </div>
      </div>
    </div>
  );
}

// Kept for backwards compat; no longer rendered.
export const LEGAL_ENTITY = null;
